<template>
    <div class="page-access page-content">
        <PageHeader title="对接文档"/>
        <div class="page-scroll-box">
            <div class="row">
                <div class="typeItem">
                    <i class="icon-android-sdk"/>
                    <div class="btn-box">
                        <div class="name">趣盟Android SDK</div>
                        <div class="oth">版本号: {{ getVersion() }}</div>
                        <div class="oth">更新时间: {{ getUpdateTime() }}</div>
                        <div class="oth">SDK开发者：{{ getCompanyName() }}</div>
                        <div class="oth">
                            主要功能：提供广告的拉取和展示功能，支持原生广告,激励视频广告，插屏广告和开屏广告，使用灵活的变现策略组合和利用算法优化广告效果，为开发者提供流量变现服务。
                        </div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goAndroidSdkDownload">下载SDK</a>
                            <a v-for="doc in androidDocButtons" :key="doc.id" class="btn-show" :href="doc.url" target="_blank">{{ doc.title }}<span v-if="doc.isNew" class="doc-new-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M798.8 287.3h-553C110.7 287.3 0 397.9 0 533.1v204.8h798.8c124.9 0 225.2-100.4 225.2-225.3 0.1-125-100.3-225.3-225.2-225.3zM346.7 630.8l-48-0.2-68.9-150c-3.6-7.8-6-14.1-7.5-18.9h-0.7c-0.5 8-2 20.3-4.8 36.9l-21.4 131.5-44.4-0.1 37.5-231.2 51.1 0.2 66.1 145.8c4.4 9.6 7 15.8 8 18.4h0.8c0-5.6 1.2-16.2 3.8-32l21.4-131.8 44.4 0.1-37.4 231.3z m212.7-190.2l-78.1-0.2-8.9 54.5 72.6 0.2-6.5 40.1-72.6-0.2-9.1 56 83.2 0.4-6.5 40.3-130.1-0.5L440.9 400l125 0.5-6.5 40.1z m241.9 192l-52.1-0.2-13-150.9c-0.6-8.1-0.5-16.6 0.6-25.5h-0.6c-2.6 10.4-5.4 18.9-8.1 25.5L665.3 632.1l-54-0.2-21.1-231.5 51.4 0.2 7.3 156.9c0.2 6.9-0.1 15.5-1.2 26h1c1.7-8.1 4.7-17 8.7-26.7l66.1-155.9 49.7 0.2 11.5 158.1c0.5 6.2 0.4 14.5-0.4 24.5h0.8c1.7-8.6 4.2-17.1 7.4-25.4l57.4-156.9 47.5 0.2-96.1 231z m0 0" fill="#d81e06"/></svg></span></a>
                        </div>
                    </div>
                </div>
                
                <div class="typeItem">
                    <i class="icon-ios-sdk"/>
                    <div class="btn-box">
                        <div class="name">趣盟iOS SDK</div>
                        <div class="oth">版本号: {{ content.ios.version }}</div>
                        <div class="oth">更新时间: {{ content.ios.updateTime }}</div>
                        <div class="oth">SDK开发者：{{ getCompanyName() }}</div>
                        <div class="oth">
                            主要功能：提供广告的拉取和展示功能，支持原生广告,激励视频广告，插屏广告和开屏广告，使用灵活的变现策略组合和利用算法优化广告效果，为开发者提供流量变现服务。
                        </div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goIosSdkDownload">下载SDK</a>
                            <a v-for="doc in iosDocButtons" :key="doc.id" class="btn-show" :href="doc.url" target="_blank">{{ doc.title }}<span v-if="doc.isNew" class="doc-new-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M798.8 287.3h-553C110.7 287.3 0 397.9 0 533.1v204.8h798.8c124.9 0 225.2-100.4 225.2-225.3 0.1-125-100.3-225.3-225.2-225.3zM346.7 630.8l-48-0.2-68.9-150c-3.6-7.8-6-14.1-7.5-18.9h-0.7c-0.5 8-2 20.3-4.8 36.9l-21.4 131.5-44.4-0.1 37.5-231.2 51.1 0.2 66.1 145.8c4.4 9.6 7 15.8 8 18.4h0.8c0-5.6 1.2-16.2 3.8-32l21.4-131.8 44.4 0.1-37.4 231.3z m212.7-190.2l-78.1-0.2-8.9 54.5 72.6 0.2-6.5 40.1-72.6-0.2-9.1 56 83.2 0.4-6.5 40.3-130.1-0.5L440.9 400l125 0.5-6.5 40.1z m241.9 192l-52.1-0.2-13-150.9c-0.6-8.1-0.5-16.6 0.6-25.5h-0.6c-2.6 10.4-5.4 18.9-8.1 25.5L665.3 632.1l-54-0.2-21.1-231.5 51.4 0.2 7.3 156.9c0.2 6.9-0.1 15.5-1.2 26h1c1.7-8.1 4.7-17 8.7-26.7l66.1-155.9 49.7 0.2 11.5 158.1c0.5 6.2 0.4 14.5-0.4 24.5h0.8c1.7-8.6 4.2-17.1 7.4-25.4l57.4-156.9 47.5 0.2-96.1 231z m0 0" fill="#d81e06"/></svg></span></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="typeItem">
                    <i class="icon-data"/>
                    <div class="btn-box">
                        <div class="name">数据查询API</div>
                        <div class="oth">版本号: 1.0.0</div>
                        <div class="oth">&nbsp;</div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goDataDetail">接入文档</a>
                            <a class="btn-show" @click="getToken">查看密钥</a>
                        </div>
                    </div>
                </div>
                <div class="typeItem">
                    <i class="icon-ad-slot"/>
                    <div class="btn-box">
                        <div class="name">流量管理API</div>
                        <div class="oth">版本号: 1.2.0</div>
                        <div class="oth">&nbsp;</div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goAdSlotDetail">接入文档</a>
                            <a class="btn-show" @click="getToken">查看密钥</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="typeItem" v-if="previewDocsVisible">
                    <i class="icon-preview-docs"/>
                    <div class="btn-box">
                        <div class="name">先审后投API</div>
                        <div class="oth">版本号: 1.0.0</div>
                        <div class="oth">&nbsp;</div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goPreviewDocs">接入文档</a>
                            <a class="btn-show" @click="getToken">查看密钥</a>
                        </div>
                    </div>
                </div>
                <div class="typeItem" v-if="reviewDocsVisible">
                    <i class="icon-review-docs"/>
                    <div class="btn-box">
                        <div class="name">先投后审API</div>
                        <div class="oth">版本号: 1.0.0</div>
                        <div class="oth">&nbsp;</div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goReviewDocs">接入文档</a>
                            <a class="btn-show" @click="getToken">查看密钥</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <el-dialog :visible.sync="visibleIosDownload" title="趣盟iOS SDK下载" width="500px">
            <el-form label-position="right" label-width="180px" size="mini">
                <el-form-item label="推荐使用">
                    <el-button type="text" @click="goIosSdkDownloadAction(content.ios.downloadUrlQuMeng)"
                               style="padding-top: 5px;font-size: 16px;">趣盟 SDK(QuMengAdSDK)
                    </el-button>
                </el-form-item>
                <el-form-item label="备选">
                    <el-button type="text" @click="goIosSdkDownloadAction(content.ios.downloadUrlQM)"
                               style="padding-top: 3px;font-size: 14px;">趣盟 SDK(QMAdSDK)
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import {isHL} from '@/common/utils';
import axios from 'axios';
import { getUserInfo } from '@/apis/login';
import { getDocList, isRecentlyUpdated } from '@/apis/docConfig';

// 女娲石文档配置（doc_id + 按钮显示名，qmOnly=true 仅趣盟显示，hlOnly=true 仅海量显示）
const qmAndroidConfig = [
    { doc_id: 1, doc_title: '接入文档', qmOnly: true },
    { doc_id: 8, doc_title: '接入文档', hlOnly: true },
    { doc_id: 5, doc_title: '隐私政策', qmOnly: true },
    { doc_id: 6, doc_title: '合规使用说明', qmOnly: true }
];
const qmiOSConfig = [
    { doc_id: 4, doc_title: '接入文档' },
    { doc_id: 5, doc_title: '隐私政策', qmOnly: true },
    { doc_id: 9, doc_title: '合规使用说明', qmOnly: true }
];

export default {
    data() {
        return {
            userInfo: {},
            visibleIosDownload: false,
            content: {
                android: {},
                androidHL: {},
                ios: {}
            },
            serverTime: '',     // 服务器时间（用于红点判断）
            androidDocButtons: [], // 女娲石文档按钮（Android）
            iosDocButtons: [],     // 女娲石文档按钮（iOS）

            previewDocsVisible: false, // 先审后投
            reviewDocsVisible: false, // 先投后审
        }
    },
    components: {
        PageHeader,
    },
    methods: {
        async init() {
            // 1. SDK 版本/下载信息（旧 JSON，不动）
            axios.get('https://docs.qttunion.com/android_sdk/qumeng_sdk_ios_android.json').then(res => {
                this.content.android = res.data.android[0];
                this.content.androidHL = res.data.androidHL[0];
                this.content.ios = res.data.ios[0];
            }).catch(err => {
                console.error('err >>> ', err);
            });

            // 2. 文档按钮从女娲石获取（/api/doc/external/list）
            const allConfigs = [...qmAndroidConfig, ...qmiOSConfig];
            const uniqueIds = [...new Set(allConfigs.map(c => c.doc_id))];
            const { server_time, docs } = await getDocList(uniqueIds);
            this.serverTime = server_time;

            this.androidDocButtons = qmAndroidConfig
                .filter(c => (!c.qmOnly || this.checkHaiLiang()) && (!c.hlOnly || !this.checkHaiLiang()))
                .map(c => {
                    const doc = docs.find(d => d.id == c.doc_id);
                    return {
                        id: c.doc_id,
                        title: c.doc_title,
                        url: doc && doc.url ? (Array.isArray(doc.url) ? doc.url[0] : doc.url) : '',
                        isNew: doc ? isRecentlyUpdated(doc.publish_time, server_time) : false,
                    };
                })
                .filter(c => c.url);
            this.iosDocButtons = qmiOSConfig
                .filter(c => (!c.qmOnly || this.checkHaiLiang()) && (!c.hlOnly || !this.checkHaiLiang()))
                .map(c => {
                    const doc = docs.find(d => d.id == c.doc_id);
                    return {
                        id: c.doc_id,
                        title: c.doc_title,
                        url: doc && doc.url ? (Array.isArray(doc.url) ? doc.url[0] : doc.url) : '',
                        isNew: doc ? isRecentlyUpdated(doc.publish_time, server_time) : false,
                    };
                })
                .filter(c => c.url);

            // 3. 用户权限
            const userInfo = await getUserInfo({});
            if (userInfo && userInfo.data && userInfo.data.auth) {
                this.previewDocsVisible = userInfo.data.auth.preview_auth === 1;
                this.reviewDocsVisible = userInfo.data.auth.review_auth === 1;
            }
        },

        checkHaiLiang() {
            return !isHL();
        },
        getCompanyName() {
            if (isHL()) return '上海趣圈圈信息科技有限公司';
            return '上海芸晞信息科技有限公司';
        },
        getVersion() {
            if (isHL()) return this.content.androidHL.version;
            return this.content.android.version;
        },
        getUpdateTime() {
            if (isHL()) return this.content.androidHL.updateTime;
            return this.content.android.updateTime;
        },

        goAndroidSdkDownload() {
            if (isHL()) {
                window.open(this.content.androidHL.downloadUrl);
            } else {
                window.open(this.content.android.downloadUrl);
            }
        },
        
        // ios
        goIosSdkDownload() {
            this.visibleIosDownload = true;
        },
        goIosSdkDownloadAction(url) {
            window.open(url);
        },
        
        goDataDetail() {
            window.open(`${origin}/api.html`)
        },

        // 先审后投文档
        goPreviewDocs() {
            window.open(`${origin}/preview_docs.html`)
        },

        // 先投后审文档
        goReviewDocs() {
            window.open(`${origin}/review_docs.html`)
        },

        getToken() {
            const userInfo = this.$ls.get('userInfo')
            const token = userInfo.secret_key;
            this.$alert(token, '查看秘钥', {
                confirmButtonText: '复制',
            }).then(() => {
                this.$copyText(token).then(
                    () => {
                        this.$message.success('已复制到粘贴板');
                    },
                    () => {
                        this.$message.error('当前浏览器不支持复制');
                    }
                );
            }).catch(() => {
            });
        },
        
        goAdSlotDetail() {
            window.open(`${origin}/adslot_api.html`)
        }
    },
    mounted() {
        this.init();
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/page.scss";

.page-access {
    & .page-scroll-box {
        & .row {
            margin-bottom: 20px;
            display: flex;
            
            & .typeItem {
                margin-right: 20px;
                padding-bottom: 10px;
                width: 48%;
                //max-height: 120px;
                overflow: hidden;
                display: flex;
                align-items: flex-start;
                border-radius: 4px;
                border: 1px solid #E3E7ED;
                
                & .icon-android-sdk, & .icon-ios-sdk, & .icon-data, & .icon-ad-slot, & .icon-preview-docs, & .icon-review-docs {
                    margin-top: 10px;
                    margin-left: 10px;
                    width: 62px;
                    height: 62px;
                }
                
                & .icon-android-sdk {
                    display: inline-block;
                    background-image: url('./images/icon_android_sdk.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-ios-sdk {
                    display: inline-block;
                    background-image: url('./images/icon_ios_sdk.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-data {
                    display: inline-block;
                    background-image: url('./images/icon_data.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-ad-slot {
                    display: inline-block;
                    background-image: url('./images/icon_ad_slot.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-preview-docs {
                    display: inline-block;
                    background-image: url('./images/icon_preview_docs.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-review-docs {
                    display: inline-block;
                    background-image: url('./images/icon_review_docs.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .name {
                    margin-top: 10px;
                }
                
                .btn-box {
                    display: flex;
                    flex-direction: column;
                    margin-left: 8px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    color: #303133;
                    line-height: 22px;
                    width: calc(100% - 90px);
                    
                    & .btn-row {
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        
                        & .btn-show {
                            &:last-child {
                                margin-right: 0;
                            }

                            margin-top: 6px;
                            margin-right: 15px;
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #4F90FF;
                            line-height: 20px;
                            cursor: pointer;
                            text-decoration: none;

                            .doc-new-icon {
                                display: inline-flex;
                                align-items: center;
                                margin-left: 4px;
                                vertical-align: middle;
                            }
                        }
                    }
                }
                
                & .oth {
                    font-family: "arial";
                    font-size: 12px;
                    font-weight: 400;
                    color: #999;
                    
                    & span {
                        margin: 0 8px;
                    }
                }
            }
        }
    }
}

</style>
